// Making a dropdown for mobile navigation

jQuery(document).ready(function(){
    mobileNavOpen();
    mobileNavClose();
    mobileMemberNavOpen();
    mobileMemberNavClose();
});

function mobileNavOpen() {
    jQuery('.header-nav-open').on('click', function(e){
        jQuery('header nav').css('display', 'block');
        jQuery('.header-nav-close').css('display', 'block');
        jQuery('.header-nav-open').css('display', 'none');
    });
}

function mobileNavClose() {
    jQuery('.header-nav-close').on('click', function(e){
        jQuery('header nav').css('display', 'none');
        jQuery('.header-nav-close').css('display', 'none');
        jQuery('.header-nav-open').css('display', 'block');
    });
}

function mobileMemberNavOpen() {
    jQuery('.member-nav-open').on('click', function(e){
        jQuery('.member-nav nav').css('display', 'inline-block');
        jQuery('.member-nav-close').css('display', 'inline-block');
        jQuery('.member-nav-open').css('display', 'none');
    });
}

function mobileMemberNavClose() {
    jQuery('.member-nav-close').on('click', function(e){
        jQuery('.member-nav nav').css('display', 'none');
        jQuery('.member-nav-close').css('display', 'none');
        jQuery('.member-nav-open').css('display', 'inline-block');
    });
}
